module.exports = __webpack_public_path__ + "static/img/evidence3.dc05227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/evidence3.png
// module id = nZ2m
// module chunks = 1 3